<div class="card-header">
  <label>Content Pro Message Builder</label>
</div>
@if (currentClient && currentUser) {
<div class="card-body">
  <div class="focus-ai-container">
    @if(!contentProV2Enabled) {
    <div class="focus-ai-content">
      @if (!hasUserAcceptedTermsAndConditions) {
      <div class="focus-ai-legal">
        <label>AI Content Generation Reminder</label>
        <p class="focus-ai-legal-text">
          By using this AI feature, you acknowledge and agree that all data
          entered into the system is considered Client Data and subject to the
          terms and conditions of the agreement between your company and Relay.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section">User Responsibility: </span>You
          are solely responsible for the ethical, legal, and compliant use of
          all AI-generated content.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section"
            >Financial Data Restrictions: </span
          >Do not upload files containing credit card numbers, account numbers,
          SSNs, routing numbers, or other sensitive financial information.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section">Content Limitations: </span
          >AI-generated content may contain errors, inaccuracies, or biases.
          Human oversight is required. We provide this tool without warranties
          and are not liable for consequences from generated content use.
        </p>
        <p class="focus-ai-legal-text-italic">
          By proceeding, you agree to all terms above. We reserve the right to
          modify these terms as needed.
        </p>
      </div>
      } @if (hasUserAcceptedTermsAndConditions) {
      <div class="focus-ai-builder">
        <label>Upload Your Documents</label>
        <p class="focus-ai-builder-help-text">
          Drop in your files and our AI will generate a concise, engaging
          message perfect for the Relay Feed. Summarize key insights in seconds.
        </p>
        <div
          class="upload-area"
          (drop)="fileDropped($event)"
          (dragover)="dragOver($event)"
        >
          <div class="upload-area__inner-content">
            @if (uploadedFiles.length < 5) {
            <i class="fa-solid fa-arrow-up-from-bracket upload-icon"></i>
            <div class="upload-instruction">
              Drag file here or
              <label
                class="file-upload-button"
                for="filesUploadInput"
                i18n="Label for files selection button"
              >
                Browse
              </label>
            </div>
            <span class="upload-sub-instruction"
              >Accepted Files: {{ allowedExtensions.join(', ') }}</span
            >
            <div>
              <input
                class="upload-area__hidden-input"
                id="filesUploadInput"
                type="file"
                (change)="fileSelected($event)"
                [accept]="allowedExtensions.join(', ')"
                multiple
                (cancel)="cancelFileSelection($event)"
              />
            </div>
            <span>
              <b>Limit 5 files</b>
            </span>
            } @if (uploadedFiles.length >= 5) {
            <div class="upload-limit-message">
              <label>You have reached the 5 file limit.</label>
              <p>To add new files, please delete any existing.</p>
            </div>
            }
          </div>
        </div>
      </div>
      <div>
        <ul style="list-style: none; padding-inline-start: 0">
          @for (file of uploadingFiles; track file) {
          <li>
            <rn-focus-ai-uploading-file
              [file]="file"
              [clientId]="currentClient.id"
              [messageId]="messageId"
              (remove)="removeUploadingFile($event)"
            ></rn-focus-ai-uploading-file>
          </li>
          }
        </ul>
        <ul
          style="list-style: none; padding-inline-start: 0"
          data-testid="file-list"
        >
          @for (file of uploadedFiles; track trackByFile($index, file)) {
          <li>
            <rn-focus-ai-file-item
              [clientId]="currentClient.id"
              [messageId]="messageId"
              [file]="file"
            ></rn-focus-ai-file-item>
          </li>
          }
        </ul>
        <ul style="list-style: none; padding-inline-start: 0">
          @for (file of errorFilesInSession; track trackByFile($index, file)) {
          <li>
            <rn-focus-ai-file-item
              [clientId]="currentClient.id"
              [messageId]="messageId"
              [file]="file"
            ></rn-focus-ai-file-item>
          </li>
          }
        </ul>
      </div>
      <div class="focus-ai-prompt">
        <label for="focusAiPrompt"
          >Additional Guidance <span>(optional)</span></label
        >
        <p class="prompt-help-text">
          We're already converting this into a feed-friendly message. Use this
          to guide tone, length, and focus. Do not repeat full content, refer to
          past messages.
        </p>
        <rn-form-input-state-control
          [formReference]="prompt"
          [showCharacterCount]="true"
          [totalLength]="promptCharLimit"
        >
          <textarea
            id="focusAiPrompt"
            class="form-control"
            rows="3"
            placeholder="Make it more friendly and conversational"
            [formControl]="prompt"
          ></textarea>
        </rn-form-input-state-control>
      </div>
      <button
        data-testid="generate-contentpro-msg-btn"
        id="generateFocusAiMessageButton"
        class="btn btn-primary btn-block"
        type="button"
        (click)="checkIfAiGenerated()"
        [disabled]="!uploadedFiles.length || focusAiService.isGenerating()"
      >
        Generate Message
      </button>
      }
    </div>
    } @if (contentProV2Enabled) {
    <div class="focus-ai-content">
      @if (!hasUserAcceptedTermsAndConditions) {
      <div class="focus-ai-legal">
        <label>AI Content Generation Reminder</label>
        <p class="focus-ai-legal-text">
          By using this AI feature, you acknowledge and agree that all data
          entered into the system is considered Client Data and subject to the
          terms and conditions of the agreement between your company and Relay.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section">User Responsibility: </span>You
          are solely responsible for the ethical, legal, and compliant use of
          all AI-generated content.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section"
            >Financial Data Restrictions: </span
          >Do not upload files containing credit card numbers, account numbers,
          SSNs, routing numbers, or other sensitive financial information.
        </p>
        <p class="focus-ai-legal-text">
          <span class="focus-ai-legal-section">Content Limitations: </span
          >AI-generated content may contain errors, inaccuracies, or biases.
          Human oversight is required. We provide this tool without warranties
          and are not liable for consequences from generated content use.
        </p>
        <p class="focus-ai-legal-text-italic">
          By proceeding, you agree to all terms above. We reserve the right to
          modify these terms as needed.
        </p>
      </div>
      } @if (hasUserAcceptedTermsAndConditions) {
      <div class="focus-ai-prompt">
        <label for="focusAiPrompt">Content Prompt</label>
        <rn-form-input-state-control
          [formReference]="prompt"
          [showCharacterCount]="true"
          [totalLength]="promptCharLimit"
        >
          <textarea
            id="focusAiPrompt"
            class="form-control"
            rows="10"
            placeholder="Make it more friendly and conversational"
            [formControl]="prompt"
            (keydown.enter)="
              $event.preventDefault();
              focusAiService.isGenerating() ? null : generateFocusAiMessage()
            "
          ></textarea>
        </rn-form-input-state-control>
      </div>
      <button
        data-testid="generate-contentpro-msg-btn"
        id="generateFocusAiMessageButton"
        class="btn btn-primary btn-block"
        type="button"
        (click)="generateFocusAiMessage()"
        [disabled]="
          this.prompt.value.length === 0 || focusAiService.isGenerating()
        "
      >
        <i class="fa fa-paper-plane"></i>
      </button>
      }
    </div>
    }
    <div class="focus-ai-buttons">
      @if (!hasUserAcceptedTermsAndConditions) {
      <button
        data-testid="cancel-contentpro-tscs-btn"
        class="btn cancel"
        [disabled]="focusAiService.isGenerating()"
        (click)="cancelFocusAi()"
      >
        Cancel
      </button>
      @if (!hasUserAcceptedTermsAndConditions) {
      <button
        data-testid="accept-contentpro-tscs-btn"
        class="btn btn-primary continue"
        (click)="acceptAndContinueToFocusAi()"
      >
        Continue
      </button>
      } } @if (hasUserAcceptedTermsAndConditions) {
      <button
        data-testid="discard-contentpro-msg-btn"
        class="btn cancel"
        [disabled]="focusAiService.isGenerating()"
        (click)="cancelFocusAi()"
      >
        Discard
      </button>
      @if (hasUserAcceptedTermsAndConditions) {
      <button
        data-testid="apply-contentpro-msg-btn"
        id="applyFocusAiMessageButton"
        class="btn btn-primary submit"
        [disabled]="
          !this.generatedMessageSignal() || focusAiService.isGenerating()
        "
        (click)="checkExistingContent()"
      >
        Apply
      </button>
      } }
    </div>
  </div>
</div>
}

<message-dialog
  #focusAiGenerateMessageDialog
  class="generate-dialog"
  [showAffirm]="false"
  [showCancel]="false"
>
  <div
    id="focusAiGenerateMessageDialog"
    data-testid="regenerate-contentpro-msg-dialog"
  >
    <div class="btn close-dialog" (click)="closeGenerateMessageDialog()">
      <i class="fa-solid fa-xmark fa-xl"></i>
    </div>
    <h3>Are you sure you want to generate again?</h3>
    <p>
      This will replace new AI generated content and delete the current. You
      cannot revert to previous content.
    </p>
    <div class="generate-dialog-buttons">
      <button
        data-testid="cancel-regenerate-contentpro-msg-btn"
        class="btn cancel-generate"
        type="button"
        (click)="closeGenerateMessageDialog()"
        i18n="Label for cancel button in generate dialog"
      >
        Cancel
      </button>
      <button
        data-testid="confirm-regenerate-contentpro-msg-btn"
        class="btn btn-primary confirm-generate"
        type="button"
        (click)="regenerateAiContent()"
        i18n="Label for confirm button in generate dialog"
      >
        Generate
      </button>
    </div>
  </div>
</message-dialog>

<message-dialog
  #focusAiApplyMessageDialog
  class="apply-dialog"
  [showAffirm]="false"
  [showCancel]="false"
>
  <div id="focusAiApplyMessageDialog" data-testid="apply-contentpro-msg-dialog">
    <div class="btn close-dialog" (click)="closeApplyMessageDialog()">
      <i class="fa-solid fa-xmark fa-xl"></i>
    </div>
    <h3>Are you sure you want to apply this change?</h3>
    <p>
      This will replace the message content and Action Elements that currently
      exist in the message builder with this new AI generated content. You will
      not be able to revert to previous content.
    </p>
    <div class="apply-dialog">
      <button
        data-testid="cancel-contentpro-msg-btn-dialog"
        class="btn cancel-apply"
        type="button"
        (click)="closeApplyMessageDialog()"
        i18n="Label for cancel button in apply dialog"
      >
        Cancel
      </button>
      <button
        data-testid="apply-contentpro-msg-btn-dialog"
        class="btn btn-primary confirm-apply"
        type="button"
        (click)="applyChanges()"
        i18n="Label for confirm button in apply dialog"
      >
        Apply
      </button>
    </div>
  </div>
</message-dialog>
